  angular
   .module('vppApp')
   .factory('BestAPRService', BestAPRService);
 BestAPRService.$inject = ['$rootScope', 'vppConfig'];

 function BestAPRService($rootScope, vppConfig) {
  return {
    getBestAprValues: function (apr) {

      var bestAprValues = {};
      var minAprValue = 1000;
      var maxMonths = 0;

      for (var x = 0; x < Object.keys(apr).length; x++) {
        if (Object.keys(apr)[x] != "Cash") {
          var months = Object.keys(apr)[x].substring(3);
          var aprValue = apr[Object.keys(apr)[x]];
          if (aprValue < minAprValue && months > maxMonths) {
            minAprValue = aprValue;
            maxMonths = months;
            bestAprValues.apr = aprValue;
            bestAprValues.months = months;
          }
        }
      }
      return bestAprValues;
    }
  };
}